import { EmailChangeConfirmation } from "./templates/EmailChangeConfirmation";
import { InvitationInstructions } from "./templates/InvitationInstructions";
import { NewJudgementAssignment } from "./templates/NewJudgementAssignment";
import { NewJudgementRequest } from "./templates/NewJudgementRequest";
import { NewMentorAssignment } from "./templates/NewMentorAssignment";
import { NewMentorRequest } from "./templates/NewMentorRequest";
import { PathCongrats } from "./templates/PathCongrats";
import { StatusEmail } from "./templates/StatusEmail";
import { TournamentConclusion } from "./templates/TournamentConclusion";
import { TournamentInvitation } from "./templates/TournamentInvitation";
import { UnreadNotifications } from "./templates/UnreadNotifications";

interface EmailTemplateBodyProps {
  templateName: string;
}

export const EmailTemplateBody = ({ templateName }: EmailTemplateBodyProps) => {
  switch (templateName) {
    case "notify_user_for_inactivity_email":
      return <StatusEmail />;
    case "belt_congrats":
      return <PathCongrats />;
    case "reconfirmation_instructions":
      return <EmailChangeConfirmation />;
    case "invitation_instructions":
      return <InvitationInstructions />;
    case "email_about_new_judgment_assignee":
      return <NewJudgementAssignment />;
    case "email_about_new_judgement_request":
      return <NewJudgementRequest />;
    case "email_about_new_mentor_assignee":
      return <NewMentorAssignment />;
    case "email_about_new_mentor_request":
      return <NewMentorRequest />;
    case "finished_tournament":
      return <TournamentConclusion />;
    case "started_tournament":
      return <TournamentInvitation />;
    case "unread_notifications":
      return <UnreadNotifications />;
    default:
      return null;
  }
};
